import { filterClasses } from "@swivl-mono/helpers";
import { TextArea } from "@swivl-mono/ui";
import React, { useEffect, useState } from "react";

import { lockableClick } from "./fields/TicketPropertyRow";

type EditableTitleProps = {
  value: string;
  onChange: (newValue: string) => void;
  pending?: boolean;
  locked?: boolean;
};

export function EditableTitle({ value, onChange, pending, locked }: EditableTitleProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);

  const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const len = e.currentTarget.value.length;
    e.currentTarget.setSelectionRange(len, len);
  };

  useEffect(() => {
    // Don't clobber an in-progress edit; resync on exit.
    if (isEditing) return;
    setEditValue(value);
  }, [value, isEditing]);

  const handleSubmit = () => {
    const trimmed = editValue.trim();
    if (trimmed && trimmed !== value) {
      onChange(trimmed);
    } else {
      setEditValue(value);
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === "Escape") {
      setEditValue(value);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <TextArea
        value={editValue}
        rows={1}
        autoFocus={true}
        onFocus={handleFocus}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSubmit}
        onKeyDown={handleKeyDown}
        className="heading-base-alt w-full"
      />
    );
  }

  return (
    <div className="group flex items-center gap-2">
      <h1
        onClick={lockableClick(locked, "Updating ticket titles", () => setIsEditing(true))}
        className={filterClasses("heading-base-alt text-black", locked ? "cursor-not-allowed" : "cursor-text")}
      >
        {value}
      </h1>
      {pending && <span className="text-xs text-grey-500">saving...</span>}
    </div>
  );
}
